import type { PsfSharePageState } from './types';

export const mutations = {
	toggleShared: (state: PsfSharePageState, shared: boolean): PsfSharePageState => ({
		...state,
		shared,
	}),
	/**
	 * ShareGoalCounter (CHANGE-97807).
	 */
	incrementShareCount: (state: PsfSharePageState): PsfSharePageState => ({
		...state,
		shareCount: state.shareCount + 1,
	}),
};
